import JSZip from 'jszip';
import React, { useRef, useState } from 'react';
import Webcam from 'react-webcam';
import styled from 'styled-components';
// import Button from '../core/Button';
// import Button from '../components/core/Button';
import Button from '../components/core/EPL_Button_Think';

const StyledSelfieCaptureModal = styled.div`
  display: flex;
  flex-direction: column;

  #cancel-button {
    ${'' /* color: var(--color-support_goldengatebridge); */}
    // border: 1px solid var(--color-support_goldengatebridge);
    // box-shadow: inset -10px -10px 15px rgba(255, 255, 255, 0.5), inset 10px 10px 15px rgba(70, 70, 70, 0.12);
    box-shadow: -5px -5px 9px rgb(255 255 255 / 45%), 3px 3px 14px 0px rgb(94 104 121 / 30%);
  }
  #proceed-button {
    ${'' /* background-color: var(--color-support_goldengatebridge); */}
    // border: 1px solid var(--color-support_goldengatebridge);
    color: white;
  }

  button {
    padding-top: 1.1rem;
    padding-bottom: 1.1rem;
    margin-top: 2.9rem;
    margin-bottom: 1.8rem;
  }
  .heading {
    text-align: left;
    margin-bottom: 1.1rem;
  }
  input {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  .media-wrapper {
    width: 100%;
    max-width: calc(100vw - 7.4rem);
    background-color: black;
    position: relative;
    & > img {
      width: 100%;
    }
    .webcam {
      width: 100%;
      max-width: calc(100vw - 7.4rem);
    }
  }
  .buttons {
    display: flex;
    button {
      margin-bottom: 0;
      flex: 1;
      &:first-child {
        margin-right: 2rem;
      }
    }
  }
  @media screen and (min-width: 760px) {
    .media-wrapper {
      width: 100%;
      background-color: black;
      .webcam {
        width: 100%;
      }
    }
  }
`;

const SelfieCaptureModal = ({ onClose, setSelfie }) => {
  const cam = useRef();
  const [image, setImage] = useState(null);
  const capture = () => {
    setImage(cam.current.getScreenshot());
  };
  const done = async () => {
    var zip = new JSZip();
    zip.file('selfie.jpeg', image.split('base64,')[1], {
      base64: true
    });
    const content = await zip.generateAsync({ type: 'blob' });
    setSelfie(content, image);
    onClose();
  };
  return (
    <StyledSelfieCaptureModal>
      <div className="media-wrapper">
        {!image ? (
          <Webcam
            className="webcam"
            audio={false}
            ref={cam}
            screenshotFormat="image/jpeg"
            videoConstraints={{
              width: 640,
              height: 480,
              facingMode: 'user'
            }}
          />
        ) : (
          <img src={image} alt="Selfie" />
        )}
      </div>
      <div className="buttons">
        {image ? (
          <>
            {/* <Button id='cancel-button' onClick={() => setImage(null)}>Re-capture</Button> */}
            <Button
              id="cancel-button"
              className="Btn cancel-button"
              // disabled={image===null ? false : true}
              text={"Re-capture"}
              onClick={() => setImage(null)}
              // style={{
              //     marginTop: "10px",
              //     marginBottom: "20px",
              //     backgroundColor: "#CB3443",
              //     border: "0px solid #CB3443",
              //     boxShadow: "none",
              //     width: "127px",
              //     height: "36px",
              //     borderRadius: "15px",
              //     padding: "0px",
              //     fontSize: "20px",
              // }}
            />
          </>
        ) : (
          <>
            {/* <Button id='cancel-button' onClick={onClose}>Cancel</Button> */}
            <Button
              id="cancel-button"
              className="Btn cancel-button"
              disabled={false}
              text={"Cancel"}
              onClick={onClose}
              // style={{
              //     marginTop: "10px",
              //     marginBottom: "20px",
              //     backgroundColor: "#CB3443",
              //     border: "0px solid #CB3443",
              //     boxShadow: "none",
              //     width: "127px",
              //     height: "36px",
              //     borderRadius: "15px",
              //     padding: "0px",
              //     fontSize: "20px",
              // }}
            />
          </>
        )}
        {!image ? 
          (
            <>
              {/* <Button id="proceed-button" onClick={capture}>Capture</Button> */}
              <Button
                id="cancel-button"
                className="Btn cancel-button"
                disabled={false}
                text={"Capture"}
                onClick={capture}
                // style={{
                //     marginTop: "10px",
                //     marginBottom: "20px",
                //     backgroundColor: "#CB3443",
                //     border: "0px solid #CB3443",
                //     boxShadow: "none",
                //     width: "127px",
                //     height: "36px",
                //     borderRadius: "15px",
                //     padding: "0px",
                //     fontSize: "20px",
                // }}
              />
            </>
          )
          : (
            <>
              {/* <Button id="proceed-button" onClick={done}>Done</Button> */}
              <Button
                id="proceed-button"
                className="Btn proceed-button"
                disabled={image===null ? true : false}
                text={"Done"}
                onClick={done}
                // style={{
                //     marginTop: "10px",
                //     marginBottom: "20px",
                //     backgroundColor: "#CB3443",
                //     border: "0px solid #CB3443",
                //     boxShadow: "none",
                //     width: "127px",
                //     height: "36px",
                //     borderRadius: "15px",
                //     padding: "0px",
                //     fontSize: "20px",
                // }}
              />
            </>
          )
        }
      </div>
    </StyledSelfieCaptureModal>
  );
};

export default SelfieCaptureModal;
